import { render, staticRenderFns } from "./mainMessageList.vue?vue&type=template&id=ee17bb18&scoped=true&"
import script from "./mainMessageList.vue?vue&type=script&lang=js&"
export * from "./mainMessageList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee17bb18",
  null
  
)

export default component.exports